export default __webpack_public_path__ + "static/media/ORBS.1fa140cc.svg";